import { yupResolver } from "@hookform/resolvers/yup";
import {
  Box,
  Button,
  Group,
  PasswordInput,
  Stack,
  Text,
  TextInput,
} from "@mantine/core";
import { useDisclosure } from "@mantine/hooks";
import { useForm } from "react-hook-form";
import { useClients } from "../../../hooks/useClients";
import { clientSchema } from "../../../schemas/client.schema";

export default function AddEditClientForm() {
  const { useAddEditClient, onCancel } = useClients();
  const { loading, submitData } = useAddEditClient();
  const [visible, { toggle }] = useDisclosure(false);

  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm({
    defaultValues: {
      name: "",
      email: "",
      contacts: "",
      password: "",
    },
    resolver: yupResolver(clientSchema),
  });

  return (
    <Box>
      <Box bg={"purple"} w={"100%"} px={"md"} py={"xs"}>
        <Text fw={600} size="lg" c={"white"}>
          Add Client
        </Text>
      </Box>
      <Box
        p={"md"}
        style={{ maxHeight: "calc(100vh - 50px)", overflowY: "auto" }}
      >
        <form
          onSubmit={handleSubmit((values) => {
            submitData({
              values,
              onSuccess() {
                reset();
              },
            });
          })}
        >
          <Stack>
            <TextInput
              label="Client name"
              placeholder="Full name"
              {...register("name")}
              error={errors.name?.message}
            />
            <TextInput
              label="Email"
              type="email"
              placeholder="Email address"
              {...register("email")}
              error={errors.email?.message}
            />
            <TextInput
              label="Contact number"
              placeholder="Phone number"
              {...register("contacts")}
              error={errors.contacts?.message}
            />
            <PasswordInput
              label="Password"
              placeholder="Account password"
              visible={visible}
              onVisibilityChange={toggle}
              {...register("password")}
              error={errors.password?.message}
            />
            <Group justify="space-between">
              <Button
                variant="light"
                disabled={loading}
                onClick={() => {
                  onCancel({
                    action() {
                      reset();
                    },
                  });
                }}
              >
                Cancel
              </Button>
              <Button type="submit" loading={loading}>
                Create
              </Button>
            </Group>
          </Stack>
        </form>
      </Box>
    </Box>
  );
}
